import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLang = currentLang === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-full font-medium transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
      aria-label="Cambiar idioma"
    >
      <i className="ri-global-line text-lg"></i>
      <span className="text-sm font-semibold">
        {currentLang === 'es' ? 'EN' : 'ES'}
      </span>
    </button>
  );
}